import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AlertListPanelHeaderContainer = styled(Box)`
  display: flex;
  margin: 10px 14px;
  position: inherit;
  justify-content: space-between;
  align-items: center;
`;

export const AlertLabel = styled(Typography)`
  font-weight: 500;
`;

export const AlertCount = styled(Typography)`
  font-weight: 500;
`;

export const AlertPanelHeaderContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const UnstarAllButton = styled(Button)`
  text-transform: capitalize;
  height: 36px;
  align-self: center;
  margin-right: 8px;
`;
